import { formatDate } from "./formatDate";
export function buildRows(songs) {
    let html = "";
    for (let i = 0; i < songs.length; i++) {
        const song = songs[i];
        let tags = "";
        let lastLed = "";
        if (song.latestDate) {
            const formattedDate = formatDate(song.latestDate);
            lastLed = `<span class="tag" title="This song was last led on ${formattedDate}">${formattedDate}</span>`;
        }
        if (song.status === 4) {
            tags += `<span class="tag expires" title="Expires on ${formatDate(song.expiresDate)}">Expires soon</span>`;
        }
        if (song.status === 3) {
            tags += `<span class="tag recent" title="Added on ${formatDate(song.addedDate)}">Recently added</span>`;
        }
        html += `
		<tr class="status-${song.status}">
			<td class="status" title="${[1, 3, 4].indexOf(song.status) > -1 ? "We know this song" : "We don’t know this song"}"><i class="fas fa-${[1, 3, 4].indexOf(song.status) > -1 ? "check" : "times"}"></i></td>
			<td class="song-number" title="${song.number} — ${song.name} (${song.book})">${song.number}</td>
			<td class="song-name" title="${song.number} — ${song.name} (${song.book})">
				<a href="${song.historyLink}" target="_blank">${song.name}</a>
			</td>
			<td class="tags">${tags}</td>
			<td class="song-last-led">${lastLed}</td>
			<td class="song-num-led"><span class="tag" title="This song has been led ${song.timesLead} time${Number(song.timesLead) === 1 ? "" : "s"}">${song.timesLead}</span></td>
		</tr>
		`;
    }
    return html;
}
